import axios from 'axios';
import z from 'zod';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';

export const ResponseItemSchema = z.object({
	page_name: z.string(),
	page_index: z.number(),
});

export const ResponseSchema = ResponseItemSchema.array();
export type ResponseData = z.infer<typeof ResponseSchema>;

export async function callApi(fileId: string): Promise<ResponseData> {
	const url = SERVICEBASEURL.REPORT + `/v1/pages/${fileId}`;
	const { data } = await axios.get(url);
	return ResponseSchema.parse(data);
}
